import { PartnerRegistrationFormType } from '@/components/Forms/PartnerRegistration/usePartnerRegistrationForm.ts';
import { useState } from 'react';

interface UsePartnerRegistrationModalProps {
  onSubmit?: (values: PartnerRegistrationFormType) => void;
}

const usePartnerRegistrationModal = ({
  onSubmit,
}: UsePartnerRegistrationModalProps = {}) => {
  const [open, setOpen] = useState(false);

  const openModal = () => setOpen(true);

  const closeModal = () => setOpen(false);

  const handleSubmit = (values: PartnerRegistrationFormType) => {
    // On ne ferme pas la modale ici : la soumission est asynchrone.
    // Succès -> redirection (rechargement de page) ; erreur -> la modale reste
    // ouverte pour permettre la correction (ORIAS invalide, email déjà utilisé, ...).
    onSubmit?.(values);
  };

  return {
    open,
    openModal,
    closeModal,
    handleSubmit,
  };
};

export default usePartnerRegistrationModal;
